import { Component, computed, inject, input } from '@angular/core';
import { IonText } from '@ionic/angular/standalone';
import { Failure, LocalFailure } from '@libs/core/lib/state/failure';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mtjr-error-bar',
  imports: [IonText],
  styleUrls: ['./error-bar.component.scss'],
  template: `
    @if (failure()) {
      <div
        class="rounded bg-red-500/10 dark:bg-red-500/10"
        animate.enter="error-bar-enter"
        animate.leave="error-bar-leave"
      >
        @if (effectiveMessage(); as message) {
          <div class="mb-2 break-all px-4 py-2">
            <ion-text class="text-danger dark:text-red-600">
              {{ message }}
            </ion-text>
          </div>
        }
      </div>
    }
  `,
})
export class VxErrorBarComponent {
  failure = input<Failure | undefined | null>();
  translateService = inject(TranslateService);

  effectiveMessage = computed(() => {
    const failure = this.failure();
    if (failure) {
      if (failure instanceof LocalFailure) {
        return this.translateService.instant(failure.message);
      }
      if ((failure.statusCode ?? 0) >= 500) {
        return this.translateService.instant('COMMON.SOMETHING_WENT_WRONG');
      }
      return failure.message;
    }
  });
}
